import Footer from 'components/Footer'
import Header from 'components/Header'
import * as React from 'react'
import { Button } from 'react-bootstrap'

const HEADER_TITLE = '有効期限切れ' as const
const QR_EXPIRED_MESSAGE = 'このQRコードの有効期限が切れています' as const
const QR_REISSUE_GUIDANCE = '再度QRコードの取得を行ってください。' as const
const CONTACT_US_PATH = '/contactUs' as const
const CONTACT_US_LABEL = 'お問い合わせ' as const

const SceneComponent: React.FC = () => {
  return (
    <>
      <Header title={HEADER_TITLE} />
      <main>
        <section className="mx-4 my-5">
          <div className="mt-5">
            <p>{QR_EXPIRED_MESSAGE}</p>
            <p>{QR_REISSUE_GUIDANCE}</p>
          </div>
          <div className="mt-4">
            <Button variant="success" className="w-100 py-4" href={CONTACT_US_PATH}>
              {CONTACT_US_LABEL}
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
